import React, { createContext, FC } from 'react';
import { GroupWebhooks, Webhook, WorkvivoWorkspace } from 'api';

interface Props {
  groupWebhookList?: GroupWebhooks;
}

export interface WorkvivoWebhookContextType {
  webhooks: Webhook[];
  workvivo_workspaces: WorkvivoWorkspace[];
}

const WorkvivoWebhookContext = createContext<WorkvivoWebhookContextType>({
  webhooks: [],
  workvivo_workspaces: [],
});

const WorkvivoWebhookProvider: FC<Props> = ({ groupWebhookList, children }) => {
  const values = {
    webhooks: groupWebhookList?.webhooks || [],
    workvivo_workspaces: groupWebhookList?.workvivo_workspaces || [],
  };

  return (
    <WorkvivoWebhookContext.Provider value={values}>{children}</WorkvivoWebhookContext.Provider>
  );
};

export { WorkvivoWebhookProvider, WorkvivoWebhookContext };
